// :cow: Cosmose CONFIDENTIAL :iso:
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LanguageState } from './language.state';

export const selectLanguageFeature = createFeatureSelector<LanguageState>('language');

export const selectLanguage = createSelector(
  selectLanguageFeature,
  (state: LanguageState) => {
    return state.language;
  },
);
